import { gql } from 'apollo-angular';
import { Page } from '../../entities/page/page';

import { Tenant } from '../../entities/tenant/tenant';


export const TENANTS_QUERY = gql`
query tenantsQuery($pageNumber: Int, $pageSize: Int, $sortProperty: String, $sortDirection: String, $name: String)
{
  tenants: getTenantsPaged(
    tenantFilter: {name: $name},
    sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
    pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection}
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
          name
          tenantId
      }
  }
}
`;

export interface TenantsQueryResponse {
  tenants: Page<Tenant>;
  loading: boolean;
}
